(function() {
  'use strict';
  angular.module('registration')
  .controller('dsoRequestConfirmationController', ['$scope', '$state', 'dsoRegistrationService',
    'DsoEmail',function($scope, $state, dsoRegistrationService, DsoEmail) {
      let vm = this;
      vm.updateEmail = updateEmail;
      vm.reset = reset;
      vm.model = dsoRegistrationService.dsoRegistrationModel();
      vm.model.registeredEmail = angular.copy(vm.model.email);

      function updateEmail() {
        $scope.errorControl.showErrors();
        if ($scope.dsoConfirmationForm.$valid) {
          if(!vm.model.id){
            vm.model.email = undefined;  
            $state.go('root');
          }else{	  
            DsoEmail.updateEmail({id: vm.model.id, email: vm.model.email},
            (data) => {
              $scope.dnConfirmationMessage.$show("Email has been successfully updated.");
              vm.model.registeredEmail = data.email;
              dsoRegistrationService.dsoRegistrationModel(vm.model);
            });
          }
        }
      }

      function reset() {
        $scope.errorControl.hideErrors();
        vm.model.email = undefined;
      }
  }]);
})();
